import Main from './components/Main';
import { StorytellerOptionsProvider } from './store';
import type { StorytellerOptions } from './store/types';

import '@getstoryteller/storyteller-sdk-javascript/dist/storyteller.min.css';
import './styles.scss';

export const App = ({ options }: { options: StorytellerOptions }) => (
  <StorytellerOptionsProvider options={options}>
    <Main />
  </StorytellerOptionsProvider>
);
export default App;
